import { TooltipContentProps } from 'recharts'
import { useTranslation } from 'react-i18next'
import MgDate from 'components/common/date'
import { useContext } from 'react'
import { HomeContext } from '../../state/home-context'
import { useFormatAmount } from 'core/hooks/useFormatAmount'

const toNumber = (value: number | string | ReadonlyArray<number | string>) => {
  return (value && Number.parseFloat(value.toString())) || undefined
}

const CumulativeChartTooltip = ({ active, payload }: TooltipContentProps) => {
  const { t } = useTranslation()
  const { store } = useContext(HomeContext)
  const formatAmount = useFormatAmount()
  const currency = store?.currency
  const isVisible = active

  // Graph's data:
  // payload?.[0] -> graph's line 1 ("realized")
  // payload?.[1] -> graph's line 2 ("trajectory")
  // payload?.[2] -> graph's line 3 ("forecast")
  // date is available in any of the three lines when data is available.
  const date = payload?.[0]?.payload?.date ?? payload?.[1]?.payload?.date ?? payload?.[2]?.payload?.date ?? null
  // GMV is available as either "realized" (if past date) or "forecast" (if future date)
  const GMV = payload?.[0]?.value ?? payload?.[2]?.value ?? 0
  const trajectory = payload?.[1]?.value ?? 0

  return (
    <>
      {date != null && (
        <div className="mg-cumulative-chart-tooltip" style={{ visibility: isVisible ? 'visible' : 'hidden' }}>
          {isVisible && (
            <div className="tooltip-content">
              <p className="vp-body-s">
                <MgDate value={date} />
              </p>
              <p className="vp-body-s tooltip-content-values">{`${formatAmount(toNumber(GMV), currency ?? '')} / ${formatAmount(toNumber(trajectory), currency ?? '')}`}</p>
              <p className="vp-caption tooltip-content-legend">
                {t('general.cumulative_charts.GMV') + ' / ' + t('general.cumulative_charts.trajectory_label')}
              </p>
            </div>
          )}
        </div>
      )}
    </>
  )
}
export default CumulativeChartTooltip
